import { render, staticRenderFns } from "./OrthoShoulderElbow.vue?vue&type=template&id=45f59ded&scoped=true"
import script from "./OrthoShoulderElbow.vue?vue&type=script&lang=js"
export * from "./OrthoShoulderElbow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f59ded",
  null
  
)

export default component.exports